import { KnotBlockerModel } from '../models/blockers/KnotBlockerModel';
import { MeasureTapeBlockerModel } from '../models/blockers/MeasureTapeBlockerModel';
import type { BlockerModel } from '../types';

export function isConnectedBlocker(blocker: BlockerModel): blocker is KnotBlockerModel | MeasureTapeBlockerModel {
  return blocker instanceof KnotBlockerModel || blocker instanceof MeasureTapeBlockerModel;
}
